import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { superAdminGuard } from 'src/app/core/guards/super-admin.guard';
import { CompaniesComponent } from './companies/companies.component';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import { AdminAccessHistoryComponent } from './admin-panel/admin-access-history.component';
import { AdminManagementComponent } from './admin-panel/admin-management.component';
import { AdminCompaniesComponent } from './companies/admin-companies.component';
import { NotFoundComponent } from '../not-found/not-found.component';
import { authGuard } from 'src/app/core/guards/auth.guard';
import { ProfileSettingsComponent } from './profile-settings/profile-settings.component';

const routes: Routes = [
  {
    path: 'companies',
    component: CompaniesComponent,
    canActivate: [authGuard]
  },
  {
    path: 'admin',
    component: AdminPanelComponent,
    canActivate: [authGuard, superAdminGuard],
    children: [
      {
        path: '',
        redirectTo: 'companies',
        pathMatch: 'full',
      },
      {
        path: 'companies',
        component: AdminCompaniesComponent,
      },
      {
        path: 'access-history',
        component: AdminAccessHistoryComponent,
      },
      {
        path: 'admins',
        component: AdminManagementComponent,
      },
    ],
  },
  {
    path: 'profile-settings',
    component: ProfileSettingsComponent,
    canActivate: [authGuard]
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
